module.exports = __webpack_public_path__ + "img/19.ba5c0c47.jpg";